<div class="wrapper">
    <div class="content">
        <DynamicTitle
            :elements="[{ name: 'Daily Cases', selected: true }]"
            title="reporting" />

        <div class="v-text-subtitle1">
            Daily report:
            <v-chip variant="flat" color="blue-lighten-5" class="text-indigo ml-2">
                {{ value }}
            </v-chip>
        </div>

        <v-data-table id="daily-table" :headers="headers" :items="items">
            <template v-slot:item.internalId="{ item }">
                <div>
                    <router-link :to="caseEditRoute + item.caseId">
                        {{ item.internalId }}
                    </router-link>
                </div>
            </template>
            <template v-slot:item.authorOfConcern="{ item }">
                <div>{{ item.authorOfConcern }}</div>
            </template>
            <template v-slot:item.repeatConcern="{ item }">
                <div>{{ item.repeatConcern ? "Yes" : "No" }}</div>
            </template>
            <template v-slot:item.recipient="{ item }">
                <div>{{ item.recipient }}</div>
            </template>
            <template v-slot:item.market="{ item }">
                <div>{{ item.market }}</div>
            </template>
            <template v-slot:item.brand="{ item }">
                <div>{{ item.brand }}</div>
            </template>
            <template v-slot:item.model="{ item }">
                <div>{{ item.model }}</div>
            </template>
            <template v-slot:item.theme="{ item }">
                <div>{{ item.theme }}</div>
            </template>
            <template v-slot:item.keyIssueGerman="{ item }">
                <div>{{ item.keyIssueGerman }}</div>
            </template>
            <template v-slot:item.keyIssueInternational="{ item }">
                <div>{{ item.keyIssueInternational }}</div>
            </template>
        </v-data-table>

        <v-alert
            border="start"
            density="compact"
            variant="text"
            type="info">
            If you have any questions, please contact Complaint Management
            CA-12
            <br />
            <a href="mailto:board.customercare@bmwgroup.com">
                <v-icon color="blue">mdi-email</v-icon>
                board.customercare@bmwgroup.com
            </a>
        </v-alert>
    </div>
    <SideFilter class="filter">
        <v-date-picker
            v-model="value"
            class="mt-2 mb-4"
            first-day-of-week="1"
            width="400"></v-date-picker>

        <div class="d-flex align-center">
            <v-btn class="me-2" color="warning" @click="applyFilter">
                <v-icon>mdi-filter</v-icon>
                Apply filters
            </v-btn>
            <v-btn class="me-2" color="grey" @click="resetToDefault">
                <v-icon color="white">mdi-cog</v-icon>
                Reset to default
            </v-btn>
            <div>
                <v-btn
                    variant="plain"
                    icon="mdi-tray-arrow-down"
                    size="large"
                    @click="downloadPdfReport"></v-btn>
            </div>
        </div>
    </SideFilter>
</div>